/**
 * useMunicipioFeatures — busca as flags de funcionalidades (delivery,
 * assinaturas, preciso_de) para o município corrente. Defaults = todas ligadas
 * (fail-open) para não bloquear o cadastro em caso de erro/404.
 *
 * Uso:
 *   const { delivery_enabled, preciso_de_enabled } = useMunicipioFeatures(municipioSlug);
 */
import { useEffect, useState } from 'react';
import { api } from '../services/api';

const DEFAULTS = {
  delivery_enabled: true,
  assinaturas_enabled: true,
  preciso_de_enabled: true,
};

// Cache in-memory por slug, evita refetch a cada mount durante a mesma sessão.
const cache = new Map();

export function useMunicipioFeatures(municipioSlug) {
  const [features, setFeatures] = useState(
    municipioSlug && cache.has(municipioSlug) ? cache.get(municipioSlug) : DEFAULTS
  );

  useEffect(() => {
    if (!municipioSlug) {
      setFeatures(DEFAULTS);
      return undefined;
    }
    if (cache.has(municipioSlug)) {
      setFeatures(cache.get(municipioSlug));
      return undefined;
    }
    let alive = true;
    api.get('/v2/municipio-features/public', { params: { municipio_slug: municipioSlug } })
      .then((r) => {
        if (!alive) return;
        const merged = { ...DEFAULTS, ...(r.data || {}) };
        cache.set(municipioSlug, merged);
        setFeatures(merged);
      })
      .catch(() => {
        if (alive) setFeatures(DEFAULTS);
      });
    return () => { alive = false; };
  }, [municipioSlug]);

  return features;
}

export default useMunicipioFeatures;
